// extracted by mini-css-extract-plugin
export default {"sheetNotReady":"styles_sheetNotReady__8q-16"};